import React from 'react';
import PropTypes from 'prop-types';

const FavoriteIconRedesign = ({ isFavorite = false, fillColor = '#246EFF', outlineColor = 'black' }) => {
    if (isFavorite) {
        return (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.44837 0.645688C8.36413 0.475037 8.19032 0.367001 8.00001 0.367001C7.80971 0.367001 7.6359 0.475037 7.55166 0.645688L5.35 5.10599L0.428114 5.8212C0.239767 5.84857 0.0832917 5.98049 0.0244825 6.1615C-0.0343268 6.34251 0.0147301 6.54122 0.151026 6.67406L3.71279 10.1456L2.8722 15.0485C2.84004 15.2361 2.91717 15.4257 3.07114 15.5375C3.22512 15.6494 3.42925 15.6641 3.5977 15.5756L8.00001 13.2609L12.4023 15.5756C12.5708 15.6641 12.7749 15.6494 12.9289 15.5375C13.0829 15.4257 13.16 15.2361 13.1278 15.0485L12.2872 10.1456L15.849 6.67406C15.9853 6.54122 16.0344 6.34251 15.9755 6.1615C15.9167 5.98049 15.7603 5.84857 15.5719 5.8212L10.65 5.10599L8.44837 0.645688Z"
                        fill={fillColor}
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 0.867001L10.318 5.563L15.5 6.316L11.75 9.971L12.635 15.133L8 12.696L3.365 15.133L4.25 9.971L0.5 6.316L5.682 5.563L8 0.867001Z"
                stroke={outlineColor}
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

FavoriteIconRedesign.propTypes = {
    isFavorite: PropTypes.bool,
    fillColor: PropTypes.string,
    outlineColor: PropTypes.string,
};

export default FavoriteIconRedesign;
